module.exports = __webpack_public_path__ + "static/media/JFL Library Brick Campaign.608e98b7.png";